import React, { useState } from 'react'

import Box from 'components_new/atoms/Box'
import Tag from 'components_new/atoms/Tag'

import ChipTabs from 'components_new/molecules/ChipTabs'
import SearchField from 'components_new/molecules/SearchField'
import SelectButton from 'components_new/molecules/SelectButton'
import SimpleTable from 'components_new/molecules/SimpleTable'

import { Highlighted } from 'components_new/organisms/StandardSearch/utils'

import PageLayout from 'components_new/templates/PageLayout'

import { useInternalCustomers } from 'redux/hooks/internal/Customers'

import { License, translateLicense } from 'types/GlobalCustomer'

import { useQueryParamState } from 'utils/queryHandler'

enum ECustomerType {
  REAL = 'real',
  DEMO = 'demo'
}

const CustomersPage = () => {
  const { customers, loading } = useInternalCustomers()

  const [search, setSearch] = useState('')
  const [type, setType] = useQueryParamState(
    'type',
    null,
    Object.values(ECustomerType)
  )
  const [license, setLicense] = useQueryParamState(
    'license',
    null,
    Object.values(License)
  )

  const filteredCustomers = customers.filter(
    (customer) =>
      customer.name.toLowerCase().includes(search.toLowerCase()) &&
      (!type || customer.is_demo === (type === ECustomerType.DEMO)) &&
      (!license || customer.license === license)
  )

  return (
    <PageLayout
      topbar={{
        breadcrumbs: [{ title: 'Admin' }, { title: 'Våra kunder' }]
      }}
      variant="static"
    >
      <Box sx={{ alignItems: 'center', display: 'flex', gap: 1, mb: 1 }}>
        <SearchField
          disabled={loading}
          onClear={() => setSearch('')}
          onSearch={setSearch}
          placeholder={'Sök kund'}
          size="small"
          value={search}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
        <ChipTabs
          disabled={loading}
          onChange={(value) => setType(value as ECustomerType | null)}
          options={[
            { label: 'Riktiga', value: ECustomerType.REAL },
            { label: 'Demo', value: ECustomerType.DEMO }
          ]}
          size="small"
          sx={{ flex: 1 }}
          value={type}
        />
        <SelectButton
          onChange={(value) => setLicense(value as License | null)}
          options={[
            { icon: 'Resources', id: null, title: 'Alla licenser' },
            ...Object.values(License).map((item) => ({
              id: item,
              title: translateLicense[item].display
            }))
          ]}
          placeholder={'Alla licenser'}
          showActive={true}
          value={license}
        />
      </Box>
      <SimpleTable
        columns={[
          { title: 'Kund', width: '50%' },
          { title: 'Licens' },
          { title: 'Typ av kund' }
        ]}
        hover={true}
        loading={loading}
        rows={filteredCustomers.map((customer) => ({
          cells: [
            <Highlighted key={0} text={customer.name} highlight={search} />,
            customer.license ? (
              <Tag key={1} label={translateLicense[customer.license].display} />
            ) : null,
            <Tag key={2} label={customer.is_demo ? 'Demo' : 'Riktig'} />
          ],
          href: `/internal/customers/${customer.id}`,
          id: customer.id,
          sortValues: [
            { value: customer.name },
            { value: customer.license ?? '' },
            { value: customer.is_demo ? 'Demo' : 'Riktig' }
          ]
        }))}
        sx={{ flex: 1 }}
      />
    </PageLayout>
  )
}

export default CustomersPage
